import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { Enum } from '../../data/types/constants'

export default function BankAccountPage() {
  const { t } = useTranslation()

  const filteredCreditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)
  const hasCoapplicant = filteredCreditApplication?.coApplicantFirstName !== null

  const getConcernedStepFor = (applicantType: string) => {
    return filteredCreditApplication?.requiredExternalSteps.find(
      (s) => s.applicantType === applicantType && s.externalStepId === 'bankAccount',
    )
  }

  const onStart = (link: string) => {
    window.location.replace(`${link}?redirect=${window.location}`)
  }

  const renderConditionnally = (applicantType: string) => {
    const concernedStep = getConcernedStepFor(applicantType)
    switch (concernedStep?.status) {
      case Enum.ERequiredExternalStepStatus.WaitingForClient:
        return (
          <td key={applicantType} id={applicantType}>
            <p className="h4">{t('bankAccount.waitingForClient')}</p>
            <button
              style={{ marginTop: '2rem' }}
              type="button"
              className="btn btn-blue"
              onClick={() => onStart(concernedStep.extraProperties.BankAccountRequestLink)}
            >
              <span>{t<string>('common.beginOrContinue')}</span>
              <i className="fa-regular fa-arrow-right" />
            </button>
          </td>
        )
      case Enum.ERequiredExternalStepStatus.WaitingForBank:
        return (
          <td>
            <label className="h4">{t('bankAccount.waitingForBank')}</label>
          </td>
        )
      case Enum.ERequiredExternalStepStatus.Completed:
        return (
          <td>
            <label className="h4"> {t('bankAccount.submitted')}</label>
            <div style={{ marginTop: '4rem' }}>
              <i className="fa-solid fa-check fa-2xl" style={{ color: '#5ae633', fontSize: '8rem' }} />
            </div>
          </td>
        )
      default:
        return <td />
    }
  }

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
      {filteredCreditApplication && (
        <table className="styled-table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th className="h3">{`${filteredCreditApplication?.applicantFirstName} ${filteredCreditApplication?.applicantLastName}`}</th>
              {hasCoapplicant && (
                <th className="h3">{`${filteredCreditApplication?.coApplicantFirstName} ${filteredCreditApplication?.coApplicantLastName}`}</th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              {renderConditionnally(Enum.EApplicantType.Applicant)}
              {hasCoapplicant && renderConditionnally(Enum.EApplicantType.Coapplicant)}
            </tr>
          </tbody>
        </table>
      )}
    </div>
  )
}
